/**
 * Title card — full-screen "GUMSHOE" with grain, dismissed by first
 * click/keypress, emitting `title:dismissed` exactly once. Owned by UI.
 */
import { isTouchDevice } from '../core/platform'
import type { EventBus } from '../core/types'
import {
  TITLE_CARD_ID,
  TITLE_HIDDEN_CLASS,
  TITLE_NAME,
  TITLE_OVERLINE,
  TITLE_TAGLINE_POINTER,
  TITLE_TAGLINE_TOUCH
} from './constants'
import { el } from './dom'

export interface TitleCard {
  /** Idempotent — hides the card and emits `title:dismissed` once. */
  dismiss(): void
}

export const setupTitleCard = (bus: EventBus, onDismissed: () => void): TitleCard => {
  const card = document.getElementById(TITLE_CARD_ID)
  let dismissed = false

  const dismiss = (): void => {
    if (dismissed) return
    dismissed = true
    card?.classList.add(TITLE_HIDDEN_CLASS)
    bus.emit('title:dismissed', {})
    onDismissed()
  }

  if (card) {
    card.classList.add('gum-title')
    const inner = el('div', 'gum-title-inner')
    inner.append(
      el('p', 'gum-title-overline', TITLE_OVERLINE),
      el('h1', 'gum-title-name', TITLE_NAME),
      el('div', 'gum-title-rule'),
      el('p', 'gum-title-tagline', isTouchDevice() ? TITLE_TAGLINE_TOUCH : TITLE_TAGLINE_POINTER)
    )
    card.replaceChildren(
      el('div', 'gum-title-fog'),
      el('div', 'gum-title-rain gum-title-rain-far'),
      el('div', 'gum-title-rain'),
      el('div', 'gum-title-rain gum-title-rain-near'),
      inner,
      el('div', 'gum-title-blinds'),
      el('div', 'gum-title-vignette'),
      el('div', 'gum-title-accent'),
      el('div', 'gum-grain')
    )
    card.addEventListener('click', dismiss)
  }

  return { dismiss }
}
